import React from 'react'
import Registry from './inputs/Registry';
import Navigation from './Navigation';

const Section = ({
	type = '',
	navigationProps,
	CustomNavigation,
	customNavigationColors,
	...fieldsProps
}) => {

	const SectionComponent = Registry.getSection(type);
	const hasNavigation = SectionComponent.hasNavigation;
	const NavigationComponent = CustomNavigation || Navigation;

	return (
		<div className="nf-section">
			<SectionComponent Registry={Registry} {...fieldsProps} navigationProps={navigationProps} />
			{!hasNavigation && <NavigationComponent {...navigationProps} />}
		</div>);
}

export default Section;
